import React from "react";
import { tagPurchase } from "../../../../utils/sendTag";
import useBotControlStore from "../../../../storeModules/useBotControlStore";
import findStep from "../findStep";
import { getPaymentPix } from "../../../../api/requests";
import useConsorcioStore from "../../../../storeModules/useConsorcioStore";
import useInitialConfigStore from "../../../../storeModules/useInitialConfigStore";
import useUserStore from "../../../../storeModules/useUserStore";
import { metodosPagamentoNames } from "../../../../utils/constants";
import noConnectionHandler from "../../../../utils/noConnectionHandler";
import PixPaymentImage from "../components/PixPaymentImage";
import { sanitizeUrl } from "../../../../utils/sanitize";

const handleGetPaymentPix = async () => {
  await noConnectionHandler().then(() => {
    getPaymentPix();
  });
};

const pagamentoPixSteps = [
  {
    name: "registro_pix",
    sender: "bot",
    text: "Certo! Estou <b>registrando</b> o seu <b>Pix</b>",
    action: async () => {
      handleGetPaymentPix();
    },
  },
  {
    name: "conquista_iniciada",
    sender: "bot",
    isWaitingForFetch: true,
    text: "Prontinho! Parabéns por iniciar a sua conquista!",
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("gerando_pix").index,
      });
    },
  },
  {
    name: "gerando_pix",
    sender: "bot",
    text: "Como você quer o <b>código pix</b> para pagamento? ",
    options: [
      {
        text: "COPIA E COLA",
        action: async () => {
          tagPurchase(metodosPagamentoNames.PIX);
          useBotControlStore.setState({
            currentStep: findStep("codigo_pix_copia_cola").index,
          });
        },
      },
      {
        text: "QRCODE",
        action: async () => {
          tagPurchase(metodosPagamentoNames.PIX);
          useBotControlStore.setState({
            currentStep: findStep("mensagem_qrcode_pix").index,
          });
        },
      },
      {
        text: "ALTERAR FORMA DE PAGAMENTO",
        action: () => {
          useBotControlStore.setState({
            currentStep: findStep("alterar_forma_pagamento").index,
          });
        },
      },
    ],
  },
  {
    name: "mensagem_qrcode_pix",
    sender: "bot",
    text: "Este é o <b>QRCODE</b> do Pix para o pagamento da sua primeira parcela:",
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("qrcode_pix").index,
      });
    },
  },
  {
    name: "qrcode_pix",
    sender: "bot",
    historyMessage: "[QRCODE PIX]",
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("abrir_app_banco").index,
      });
    },
    component: (
      <PixPaymentImage />
    ),
    shouldPersistComponent: true,
  },
  {
    name: "instrucao_scan_qrcode",
    sender: "bot",
    text: "Abra o aplicativo do seu banco e  <b>fotografe o QRCODE</b>",
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("retorno_qrcode_pix").index,
      });
    },
  },
  {
    name: "retorno_qrcode_pix",
    sender: "bot",
    text: "<b>Depois que você pagar</b>, volte aqui para continuar:)",
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("escolha_copia_cola").index,
      });
    },
  },
  {
    name: "escolha_copia_cola",
    sender: "bot",
    text: "Escolha uma das opções:",
    options: [
      {
        text: "CONTINUAR",
        action: () => {
          useBotControlStore.setState({
            currentStep: findStep("escolha_copia_cola").index,
          });
        },
      },
      {
        text: "COPIA E COLA",
        action: () => {
          useBotControlStore.setState({
            currentStep: findStep("codigo_pix_copia_cola").index,
          });
        },
      },
      {
        text: "ALTERAR FORMA DE PAGAMENTO",
        action: () => {
          useBotControlStore.setState({
            currentStep: findStep("alterar_forma_pagamento").index,
          });
        },
      },
    ],
  },
  {
    name: "confirmacao_pagamento_pix",
    sender: "bot",
    text: "Você já <b>realizou o pagamento</b>?",
    options: [
      {
        text: "SIM",
        action: () => {
          useBotControlStore.setState({
            currentStep: findStep("erro_confirmacao_pix")
              .index,
          });
        },
      },
      { text: "NÃO" },
    ],
  },
  {
    name: "erro_confirmacao_pix",
    sender: "bot",
    text: "OPS! Ainda não recebemos a confirmação de que seu PIX foi pago.",
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("confirma_pagamento_banco_pix").index,
      });
    },
  },
  {
    name: "confirma_pagamento_banco_pix",
    sender: "bot",
    text: "Se você já efetuou o pagamento, o Banco irá me enviar a confirmação em breve.",
    options: [
      {
        text: "CONTINUAR",
        action: () => {
          useBotControlStore.setState({
            currentStep: findStep("confirma_pagamento_banco_novamente")
              .index,
          });
        },
      },
    ],
  },
  {
    name: "confirma_pagamento_banco_novamente",
    sender: "bot",
    text: "Deixa eu consultar o seu banco novamente...",
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("email_pix_enviado").index,
      });
    },
  },
  {
    name: "email_pix_enviado",
    sender: "bot",
    text: "Enviei no seu e-mail essa confirmação e as demais orientações.",
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("mensagem_importante_pix").index,
      });
    },
  },
  {
    name: "mensagem_importante_pix",
    sender: "bot",
    text: "Você deu um passo importante para realizar as suas conquistas!",
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("mensagem_para_voce_pix").index,
      });
    },
  },
  {
    name: "mensagem_para_voce_pix",
    sender: "bot",
    text: "Vou <b>torcer muito</b> por você! :)",
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("compra_finalizada").index,
      });
    },
  },
  {
    name: "codigo_pix_copia_cola",
    sender: "bot",
    text: "Este é o código do <b>PIX CÓPIA E COLA:</b>",
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("exibe_codigo_pix").index,
      });
    },
  },
  {
    name: "exibe_codigo_pix",
    sender: "bot",
    text: () => {
      return `<p style="line-break: anywhere;">${
        useUserStore.getState().payment.pix.qrCode
      }</p>`;
    },
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("botao_copiar_pix").index,
      });
    },
  },
  {
    name: "botao_copiar_pix",
    sender: "bot",
    text: "<b>Clique</b> no botão <b>para copiar o código</b> o PIX para pagar a sua primeira parcela.",
    options: [
      {
        text: "COPIAR",
        action: () => {
          const { qrCode } = useUserStore.getState().payment.pix;
          navigator.clipboard.writeText(qrCode);

          useBotControlStore.setState({
            currentStep: findStep("confirma_pagamento_pix").index,
          });
        },
      },
    ],
  },
  {
    name: "confirma_pagamento_pix",
    sender: "bot",
    text: "Código copiado com sucesso.",
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("abrir_app_banco").index,
      });
    },
  },
  {
    name: "instrucao_banco_pix",
    sender: "bot",
    text: "Agora abra o <b>aplicativo do seu banco</b>, escolha a opção:",
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("seleciona_banco_pix")
          .index,
      });
    },
  },
  {
    name: "seleciona_banco_pix",
    sender: "bot",
    text: "Pagar com PIX Cópia e Cola.",
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("retorno_copia_cola").index,
      });
    },
  },
  {
    name: "retorno_copia_cola",
    sender: "bot",
    text: "<b>Depois que você pagar</b>, volte aqui para continuar:)",
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("continuar_pagamento").index,
      });
    },
  },
  {
    name: "erro_pix_tentar_novamente",
    sender: "bot",
    text: `<b>OPS! </b>Tivemos um problema para gerar o PIX! O quê você deseja fazer?`,
    isWaitingForFetch: true,
    options: () => {
      return useConsorcioStore
        .getState()
        .fetchedProposta.formasPagamentoDisponiveis.filter((code) =>
          [5, 0, 1].includes(code),
        )
        .map((code) => {
          const options = {
            5: {
              text: "TENTAR NOVAMENTE",
              action: () => {
                useBotControlStore.setState({
                  currentStep: findStep("registro_pix").index,
                });
              },
            },
            0: {
              text: "PAGAR COM CARTÃO",
              action: () => {
                useBotControlStore.setState({
                  currentStep: findStep("mensagem_seguranca_cartao")
                    .index,
                });
              },
            },
            1: {
              text: "PAGAR COM BOLETO",
              action: () => {
                useBotControlStore.setState({
                  currentStep: findStep("gerando_boleto").index,
                });
              },
            },
          };
          return options[code];
        })
        .concat([
          {
            text: "FALAR COM NOSSOS ESPECIALISTAS",
            action: () => {
              const linkWhatsApp =
                useInitialConfigStore.getState().linkWhatsApp;
              window.open(sanitizeUrl(linkWhatsApp), "_blank");
            },
          },
        ]);
    },
  },
];

export default pagamentoPixSteps;
